import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Percent } from 'lucide-react';
import { toast } from '../hooks/use-toast';
import { clearVatCache } from '../lib/vat';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const authHeader = () => {
  const t = localStorage.getItem('authToken');
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export const VatSettings = () => {
  const [rate, setRate] = useState('');
  const [saved, setSaved] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    axios.get(`${API}/settings/vat`).then((r) => { setRate(String(r.data.rate)); setSaved(r.data.rate); }).catch(() => {});
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      const r = await axios.put(`${API}/settings/vat`, { rate: parseFloat(rate) }, { withCredentials: true, headers: authHeader() });
      setSaved(r.data.rate);
      clearVatCache();
      toast({ title: 'נשמר', description: `שיעור המע"מ עודכן ל-${r.data.rate}%. הוא יחול על רשומות חדשות בלבד.` });
    } catch (error) {
      toast({ title: 'שגיאה', description: error.response?.data?.detail || 'לא ניתן לשמור', variant: 'destructive' });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="bg-gradient-to-br from-slate-50 to-indigo-50 p-5 rounded-lg border-2 border-indigo-200" data-testid="vat-settings">
      <h3 className="text-lg font-bold text-indigo-900 flex items-center gap-2 mb-1"><Percent className="w-5 h-5" />מע"מ</h3>
      <p className="text-sm text-gray-600 mb-3">שיעור נוכחי: <span className="font-bold" data-testid="vat-current-rate">{saved ?? '-'}%</span>. שינוי חל רק על רשומות חדשות; רשומות קיימות שומרות את השיעור שלהן.</p>
      <div className="flex items-center gap-2">
        <Input type="number" min="0" max="100" step="0.5" value={rate} onChange={(e) => setRate(e.target.value)} className="w-28 text-lg font-bold" dir="ltr" data-testid="vat-rate-input" />
        <span className="text-lg font-bold text-gray-600">%</span>
        <Button onClick={save} disabled={saving || rate === '' || parseFloat(rate) === saved} className="bg-indigo-600 hover:bg-indigo-700 text-white" data-testid="vat-save-btn">
          {saving ? 'שומר...' : 'שמור'}
        </Button>
      </div>
    </div>
  );
};
